import { action as apiAction } from 'api/Api'
import { push } from 'index'
import sweetalert from 'sweetalert2'

type Payload = {
  cardId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId } = payload

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId

  try {
    await apiAction('ArchiveCard', {
      cardId
    })

    dispatch(push('/board/' + boardId))
  } catch (error) {
    if (error.code === 539) { // Card is blocked
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
